import React from 'react'

import { ErrorView } from '@flowwai-frontend/bps-officer-web/common/ui'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'

import { ImageConstants } from '../constants'
import { noDataViewClassName } from '../styles'

const NoDataView = (): React.ReactElement => {
   const t = useCustomT('globalSearch:searchModal')

   const { theme } = useAppTheme()
   const { noDataViewBgColor } = theme.globalSearch.searchModal

   return (
      <ErrorView
         imageUrl={ImageConstants.noDataViewImageUrl}
         description={t('noResultsDescription')}
         containerClassName={`${noDataViewClassName} ${noDataViewBgColor}`}
      />
   )
}

export default NoDataView
